export default {
  filters: {
    formatDate: function(date) {
      return date.toLocaleString();
    },
    round: function(number) {
      return Math.round(number);
    }
  }
};
